import {
    Box,
    Divider,
    Text,
    Anchor,
    Avatar,
    Image,
    MediaObject,
    Paragraph,
    Tag,
    IconAwardRibbon,
} from '@zillow/constellation';
import React from 'react';

import type { Contributor } from '../../B2CPostTemplate.types';

const isExpertiseArray = (expertise: unknown): expertise is string[] =>
    Array.isArray(expertise) &&
    expertise.every((item) => typeof item === 'string');

const ContributorPopover: React.FC<{ contributor: Contributor }> = ({
    contributor,
}) => (
    <Box>
        <MediaObject
            media={
                contributor.avatar ? (
                    <Avatar size="lg">
                        <Image
                            src={contributor.avatar}
                            alt={contributor.name}
                        />
                    </Avatar>
                ) : null
            }
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                }}
            >
                <Text fontType="bodyHeading">{contributor.name}</Text>
                {contributor.jobTitle && (
                    <Text fontType="bodySmall" fontColor="textMedium">
                        {contributor.jobTitle}
                    </Text>
                )}
            </Box>
        </MediaObject>
        {/* Divider */}
        <Divider marginY="xs" />
        {isExpertiseArray(contributor.expertise) &&
            contributor.expertise.length > 0 && (
                <>
                    <MediaObject
                        gutter="xxs"
                        media={
                            <IconAwardRibbon
                                size="xs"
                                fontColor="blue500"
                                marginTop="xxs"
                            />
                        }
                    >
                        <Paragraph fontType="bodyHeading" fontColor="blue500">
                            Expertise
                        </Paragraph>
                    </MediaObject>
                    <Box
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '$spacing.xs',
                            marginTop: '$spacing.sm',
                            marginBottom: '$spacing.sm',
                        }}
                    >
                        {contributor.expertise.map((item) => (
                            <Tag
                                key={item}
                                appearance="info"
                                textTransform="none"
                            >
                                {item}
                            </Tag>
                        ))}
                    </Box>
                </>
            )}
        {contributor.description && (
            <Text fontType="bodySmall" fontColor="textDark" textAlign="left">
                {contributor.description.length > 120
                    ? `${contributor.description.slice(0, 120)}\u2026`
                    : contributor.description}
            </Text>
        )}
        {contributor.link && (
            <Box sx={{ marginTop: '$spacing.xs' }}>
                <Text as="p" fontType="bodyHeading" fontColor="brand">
                    <Anchor href={contributor.link} target="_blank">
                        Read more
                    </Anchor>
                </Text>
            </Box>
        )}
    </Box>
);

export default ContributorPopover;
